module.exports = __webpack_public_path__ + "static/img/A80.132d489d.jpg";